import { IIcon } from '~/components/ui/Icon'

export default function ListView({ size, color }: Pick<IIcon, 'size' | 'color'>) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24'>
      {/* Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ */}
      <path
        fill={color}
        fillRule='evenodd'
        d='M3.25 7A.75.75 0 0 1 4 6.25h16a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 7m0 5a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75'
        clipRule='evenodd'
      />
    </svg>
  )
}
